/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import {Environment, getEnvironment} from '@ion/core/src/environment/environment';
import {hasRole} from '@ion/core/src/security/helpers';
import {User} from '@ion/core/src/types/entities';

/**
 * Defines the Role IDs for the CalAmp Support Role in each environment.
 */
const CalAmpSupportRoleIds = {
  [Environment.dev] : [43139],
  [Environment.qa]  : [17072],
  [Environment.stg] : [8933],
  [Environment.us]  : [3536],
  [Environment.eu]  : [5711]
};

/**
 * Defines the Role IDs for the `Internal Vehicle Engineering` Role in each environment.
 */
const CalampInternalVESRoleIds = {
  [Environment.dev] : [110598],
  [Environment.qa]  : [116340],
  [Environment.stg] : [11434],
  [Environment.us]  : [8649],
  [Environment.eu]  : [10237]
};

/**
 * Checks if the user has the CalAmp Support Role.
 */
export const hasCalAmpSupportRole = (user: User): boolean => {
  const environment = getEnvironment();
  if (environment === Environment.local) {
    return (
      hasRole(user?.roles, CalAmpSupportRoleIds[Environment.qa]) ||
      hasRole(user?.roles, CalAmpSupportRoleIds[Environment.dev]) ||
      hasRole(user?.roles, CalAmpSupportRoleIds[Environment.us])
    );
  }
  return hasRole(user?.roles, CalAmpSupportRoleIds[environment]);
};

/**
 * Checks if the user has the `Internal Vehicle Engineering` Role.
 */
export const hasInternalVehicleEngineeringRole = (user: User): boolean => {
  const environment = getEnvironment();
  if (environment === Environment.local) {
    return (
      hasRole(user?.roles, CalampInternalVESRoleIds[Environment.qa]) ||
      hasRole(user?.roles, CalampInternalVESRoleIds[Environment.dev]) ||
      hasRole(user?.roles, CalampInternalVESRoleIds[Environment.us]) ||
      hasRole(user?.roles, CalampInternalVESRoleIds[Environment.eu])
    );
  }
  return hasRole(user?.roles, CalampInternalVESRoleIds[environment]);
};
